import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { DataChangeLogComponent } from "@components/data-change-log/data-change-log.component";
import { InputComponent } from "@components/input/input.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { ShowHideComponent } from "@components/show-hide/show-hide.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { HandelssortimentDTO } from "~app/common/models/handelssortiment/HandelssortimentDTO";
import { RavaruHandelssortimentDTO } from "~app/common/models/handelssortiment/RavaruHandelssortimentDTO";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IHandelssortimentSearchParamsModel } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { IRelateratHandelssortiment } from "~app/features/planera/model/IHandelssortiment";
import { HandelssortimentService } from "../../handelssortiment.service";

@Component({
    selector: "rask-handelssortiment-header",
    styleUrls: ["./header.component.scss"],
    templateUrl: "./header.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        TranslateDirective,
        NgbPopover,
        AddButtonComponent,
        SelectorComponent,
        RouterLink,
        TextmultilineComponent,
        ShowHideComponent,
        DataChangeLogComponent,
        TranslatePipe
    ]
})
export class HeaderComponent implements OnChanges {
    @Input() foradlingsHandelssortiment: RavaruHandelssortimentDTO[];
    @Input() form: UntypedFormGroup;
    @Input() handelssortiment: HandelssortimentDTO;
    @Output() handelssortimentChange = new EventEmitter();
    handelssortimentSearchParams: IHandelssortimentSearchParamsModel;
    ravaruHandelssortimentId: any;
    @Input() relateradeHandelssortiment: HandelssortimentDTO[];
    relateratHandelssortimentId: any;
    relateratHandelssortimentVisible: boolean;
    @Input() validationContext: IValidationContext;

    private readonly handelssortimentService = inject(HandelssortimentService);

    canAddRelated(): boolean {
        return !this.relateratHandelssortimentVisible && this.relateradeHandelssortiment.length === 0 && !this.form.disabled;
    }

    formatter = (result: IRelateratHandelssortiment) => result ? result.namn : undefined;

    getHandelssortiment = () => this.handelssortimentService.getHandelssortimentBasData();

    searchForHandelssortiment = (searchString: string) => {
        this.handelssortimentSearchParams = {
            aktiv: true,
            skipForadlade: true
        };
        this.handelssortimentSearchParams.namn = searchString;
        return this.handelssortimentService.searchForHandelssortiment(this.handelssortimentSearchParams);
    };

    getInitSelectedHandelssortiment = (id: number) => {
        this.handelssortimentSearchParams = { aktiv: true };
        this.handelssortimentSearchParams.ids = [id];
        return this.handelssortimentService.searchForHandelssortiment(this.handelssortimentSearchParams);
    };

    searchForRelaterbaraHandelssortiment = (searchString: string) => this.handelssortimentService.searchForRelaterbaraHandelssortiment(this.handelssortiment.id, searchString);

    getInitSelectedRelateratHandelssortiment = (id: number) => this.handelssortimentService.searchForRelaterbaraHandelssortiment(this.handelssortiment.id, `${id}`);

    inNewMode() {
        return !this.handelssortiment.id;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.handelssortiment) {
            this.relateratHandelssortimentVisible = this.inNewMode() || !!this.handelssortiment.relateratHandelssortimentId;
        }
    }

    outputFormatter = (result: IRelateratHandelssortiment) => result ? result.id : undefined;

    showRelateraHandelssortiment = () => {
        this.relateratHandelssortimentVisible = true;
    };
}
